import React, { Component, Fragment } from 'react';
import { Row } from 'react-bootstrap';

class Documents extends Component {
	constructor(props) {
		super(props)
	
		this.state = {
			links: [{
                Title: "Integration",
                Description: "Information about how each environment is linked between the Integration Apis and AX", 
                Urls: ["https://carlislehomes.atlassian.net/wiki/spaces/API/pages/617676837/Integration+Overview"]
            }]
		}
	}

    render() {
		return (
			<Fragment>
                    {
                        this.state.links.map((item, key) => {
                            return (
                                <Row>
                                    <div className="card bg-light">
                                        <div className="card-body">
                                            <h5 class="card-title"><b>{item.Title}</b></h5>
                                            <p class="card-text">{item.Description}</p>
                                            <div>Links:</div>
                                            <ol>
                                            {
                                                item.Urls.map((url, key) => {
                                                    return (
                                                        <li>
                                                            <a target="_blank" href={url}>{url}</a>
                                                        </li>
                                                    )
                                                })
                                            }
                                            </ol>
                                        </div>
                                    </div>
                                </Row>
                            );
                        })
                    }
            </Fragment>
        )
    }
}

export default Documents;